module.exports = __webpack_public_path__ + "static/media/defaultBackground.2f2c4e4c.png";